var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from 'clsx';
import { useCombobox } from 'downshift';
import { useEffect, useState } from 'react';
import { useProfileContext } from '../ProfileContext';
import LineWithRoundedCaps from './LineWithRoundedCaps';
import { SIGNUP_BREED_LIST } from '@variables';
var _MAX_SUGGESTIONS = 6;
var PetBreedInput = function (_a) {
    var breed = _a.breed, label = _a.label, petType = _a.petType, handlePetBreedChange = _a.handlePetBreedChange, validatePetBreed = _a.validatePetBreed;
    var serverLoading = useProfileContext().serverLoading;
    var _b = useState(true), isValid = _b[0], setIsValid = _b[1];
    var _c = useState(''), error = _c[0], setError = _c[1];
    useEffect(function () {
        var _a = validatePetBreed(breed), isValid = _a.isValid, error = _a.error;
        setIsValid(isValid);
        setError(error);
    }, [breed]);
    // Filter the breeds based on the input value and limit to 6 items
    var filteredBreeds = SIGNUP_BREED_LIST[petType]
        .filter(function (b) { return b.toLowerCase().includes(breed.toLowerCase()); })
        .slice(0, _MAX_SUGGESTIONS);
    var _d = useCombobox({
        items: filteredBreeds,
        inputValue: breed,
        onInputValueChange: function (_a) {
            var inputValue = _a.inputValue;
            handlePetBreedChange(inputValue);
        },
        onSelectedItemChange: function (_a) {
            var selectedItem = _a.selectedItem;
            downshiftSetInputValue(selectedItem);
            handlePetBreedChange(selectedItem);
        },
    }), isOpen = _d.isOpen, getMenuProps = _d.getMenuProps, getInputProps = _d.getInputProps, getItemProps = _d.getItemProps, highlightedIndex = _d.highlightedIndex, downshiftSetInputValue = _d.setInputValue;
    var textColorStyle = isValid ? 'text-text-body' : 'text-error-red';
    var borderStyle = isValid
        ? 'border-2 border-transparent bg-transparent'
        : 'border-2 border-error-red bg-bone';
    var id = 'breed-select';
    return (_jsxs("div", __assign({ className: "grid grid-cols-1 gap-6 md:gap-20" }, { children: [_jsx("label", __assign({ className: "text-center", htmlFor: "breed-select" }, { children: label })), _jsx("div", __assign({ className: clsx('rounded-sm2 px-4 pt-5 py-6 md:p-6', borderStyle) }, { children: _jsxs("div", __assign({ className: "w-[241px] md:w-full mx-auto" }, { children: [_jsx("div", __assign({ className: "w-full" }, { children: _jsx("input", __assign({ className: clsx(textColorStyle, 'truncate w-full text-2xl-head-m md:text-3xl-head-d font-display bg-transparent border-0 placeholder:text-state-inactive-md focus:outline-none') }, getInputProps({
                                disabled: serverLoading,
                                id: id,
                                placeholder: 'Breed',
                                type: 'select',
                                value: breed,
                            }))) })), _jsx(LineWithRoundedCaps, {}), error && (_jsx("div", __assign({ id: "".concat(id, "Error"), className: "text-sm-reg-m md:text-sm-reg-d mt-5 text-center self-center text-state-error" }, { children: error }))), _jsxs("div", __assign({ className: "w-full grid grid-cols-1 gap-4" }, { children: [isOpen && breed.length >= 3 && filteredBreeds.length > 0 && _jsx("p", { children: "Suggestions" }), _jsx("ul", __assign({}, getMenuProps(), { className: clsx('grid grid-cols-1 gap-4 w-full z-10') }, { children: isOpen &&
                                        breed.length >= 3 &&
                                        filteredBreeds.map(function (breed, index) { return (_jsx("li", __assign({}, getItemProps({ item: breed, index: index }), { className: clsx('text-xs-head-m md:text-xs-head-d font-display cursor-pointer', highlightedIndex === index && 'underline') }, { children: breed }), index)); }) }))] }))] })) }))] })));
};
export default PetBreedInput;
